import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { Tooltip } from "~/components/Tooltip";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const TERM_LENGTH_YEARS_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.termLengthYears,
    sortsOn: AssetColumns.termLengthYears,
    label: "Term Length",
    tooltip: CatalogReferenceDataSlugs.term_length_years,
    type: "years",
    width: 150,
    cellValue: (item) => {
        if (item.isAsset) {
            return item.term_length_years;
        }

        return null;
    },
};

export const TERM_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.termDescription,
    sortsOn: AssetColumns.termDescription,
    label: "Term Description",
    tooltip: CatalogReferenceDataSlugs.term_description,
    type: ColumnTypes.string,
    width: 320,
    render: (item) => {
        if (!item.isAsset) {
            return <Emdash />;
        }

        const value = item.term_description;
        if (!value) {
            return <Emdash />;
        }

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="px-3 py-2 text-sm max-w-sm whitespace-pre-line">
                        {value}
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span ref={setTriggerRef} className="line-clamp-2">
                        {value}
                    </span>
                )}
            </Tooltip>
        );
    },
};
